<!-- #region First -->
<section [ngClass]="lang" class="first pt-5">
  <div class="container">
    <div class="row">

      <div class="col-md-6 col-sm-12 pt-5 pb-5 pr-5 wow fadeInLeft">
        <img src="../../../../assets/images/Services/1.svg" alt="Logo" class="logo" (load)="onLoading('Logo')">
        <div [id]="'Logo'" class="spinner-grow text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>

      <div class="col-md-6 col-sm-12 m-auto wow fadeInRight">

        <h2 *ngIf="lang=='en'" class="text-center">Our Services</h2>
        <h2 *ngIf="lang=='ar'" class="text-center">خدماتنا</h2>

        <P *ngIf="lang=='en'">
          We strive to provide high-quality software and technical solutions in the information and communication
          technology (ICT) facilities.
        </P>
        <P *ngIf="lang=='ar'">
          نحن نسعى جاهدين لتوفير برامج وحلول تقنيية عالية الجودة في مجال تكنولوجيا المعلومات والاتصالات (ICT).
        </P>

      </div>

    </div>
  </div>
</section>
<!-- #endregion -->

<!-- #region Services Info -->
<section [ngClass]="lang" class="servces-info pt-5">
  <div class="container">
    <div class="row">

      <div class="col-md-7 col-sm-12">

        <div class="row">

          <article id="Consulting" class="item col-12 wow fadeInUp" data-wow-delay="0.15s">

            <aside class="col-3">
              <img src="../../../../assets/images/Services/Consulting.svg" alt="Consulting" (load)="onLoading('Consulting1')">
              <div [id]="'Consulting1'" class="spinner-grow text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </aside>

            <aside *ngIf="lang=='en'" class="col-12">
              <h3>IT Consulting</h3>
              <section class="text-justify">
                <P>
                  Our clients are helped to improve their performance through analysis of existing business problems and
                  development of future plans.
                </P>
                <ul>
                  <li># Best Practices</li>
                  <li># Excellence Centers</li>
                  <li># Project Management</li>
                  <li># ITIL</li>
                  <!-- <li># ISO 27001</li> -->
                </ul>
              </section>
            </aside>

            <aside *ngIf="lang=='ar'" class="col-12">
              <h3>إستشارات تقنية</h3>
              <section class="text-justify">
                <p>
                  نساعد عملائنا على تحسين أدائهم من خلال تحليل مشاكل العمل الحالية وتطوير الخطط المستقبلية.
                </p>
                <ul>
                  <li># مراكز التميز</li>
                  <li># إدارة المشاريع</li>
                  <li># مكتبة البنية التحتية للمعلوماتية</li>
                  <!-- <li># ISO 27001 معايير</li> -->
                </ul>
              </section>
            </aside>

          </article>

          <article id="ERP" class="item col-12 wow fadeInUp" data-wow-delay="0.2s">

            <aside class="col-3">
              <img src="../../../../assets/images/Services/ERP.svg" alt="ERP" (load)="onLoading('Consulting2')">
              <div [id]="'Consulting2'" class="spinner-grow text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </aside>

            <aside *ngIf="lang=='en'" class="col-12">
              <h3>Outsourcing</h3>
              <section class="text-justify">
                <P>
                  Our outsource services offering consists of integrated smart technologies, in-depth expertise, special
                  delivery approach, and advanced tools and processes. We enable our clients to implement a unique
                  strategy aimed at helping them address their business demands and meet new challenges. we offer our
                  services across six core domains that can be tailored to our customers’ budget and business goals:
                </P>
                <ul>
                  <li># IT Infrastructure Management</li>
                  <li># Information Security Management</li>
                  <li># Networks Management</li>
                  <li># Service Desk Management</li>
                  <li># Monitoring Management</li>
                  <li># Applications Management</li>
                </ul>
              </section>
            </aside>

            <aside *ngIf="lang=='ar'" class="col-12">
              <h3>إدارة وتشغيل</h3>
              <section class="text-justify">
                <P>
                  تألف عرض خدمات الادارة والتشغيل الخاص بنا من تقنيات ذكية متكاملة وخبرة متعمقة ومنهج توصيل خاص وأدوات
                  وعمليات متقدمة. نحن نمكن عملائنا من تنفيذ إستراتيجية فريدة تهدف إلى مساعدتهم على تلبية متطلبات أعمالهم
                  ومواجهة التحديات الجديدة. نقدم خدماتنا عبر ستة مجالات أساسية يمكن تكييفها وفقًا لميزانية عملائنا
                  وأهداف العمل الخاصة بهم:
                </P>
                <ul>
                  <li># إدارة البنية التحتية لتكنولوجيا المعلومات</li>
                  <li># إدارة امن المعلومات</li>
                  <li># إدارة الشبكات</li>
                  <li># إدارة الدعم الفني</li>
                  <li># إدارة المراقبة</li>
                  <li># إدارة التطبيقات</li>
                </ul>
              </section>
            </aside>

          </article>

          <article id="WebServices" class="item col-12 wow fadeInUp" data-wow-delay="0.25s">

            <aside class="col-3">
              <img src="../../../../assets/images/Services/WebServices.svg" alt="WebServices" (load)="onLoading('Consulting3')">
              <div [id]="'Consulting3'" class="spinner-grow text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </aside>

            <aside *ngIf="lang=='en'" class="col-12">
              <h3>Enterprise Solutions</h3>
              <section class="text-justify">
                <P>
                  We offer various agile modules to automate your business process from end to end.
                </P>
                <ul>
                  <li># Enterprise Resource Planning</li>
                  <li># Customer Relationship Management</li>
                  <li># Document Management System</li>
                  <li># Business Process Management</li>
                  <li># E-Commerce platforms</li>
                  <li># Mobile Smart Phone Applications (Android,IOS)</li>
                </ul>
              </section>
            </aside>

            <aside *ngIf="lang=='ar'" class="col-12">
              <h3>حلول أنظمة المؤسسات</h3>
              <section class="text-justify">
                <P>
                  لدينا حلول مبتكرة لأتمتة العمليات الادارية عملك من البداية إلى النهاية
                </P>
                <ul>
                  <li># تخطيط موارد المشاريع</li>
                  <li># إدارة علاقات العملاء</li>
                  <li># نظم إدارة الوثائق</li>
                  <li># إدارة عمليات التجارية</li>
                  <li># منصات التجارة الإلكترونية</li>
                  <li># تطبيقات الهاتف المحمول</li>
                </ul>
              </section>
            </aside>

          </article>

          <article id="MobileApplications" class="item col-12 wow fadeInUp" data-wow-delay="0.3s">

            <aside class="col-3">
              <img src="../../../../assets/images/Services/MobileApplications.svg" alt="MobileApplications" (load)="onLoading('Consulting4')">
              <div [id]="'Consulting4'" class="spinner-grow text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </aside>

            <aside *ngIf="lang=='en'" class="col-12">
              <h3>E-Marketing</h3>
              <section class="text-justify">
                <P>
                  We help our clients to communicate with targeted audiences by creating digital content and platforms
                  that people actually like and want to use.
                </P>
                <ul>
                  <li># Website Development</li>
                  <li># Auditing</li>
                  <li># Planning</li>
                  <li># Research</li>
                  <li># Creative Designs</li>
                  <li># Search Engine Marketing</li>
                  <li># Social Media Marketing</li>
                </ul>

              </section>
            </aside>

            <aside *ngIf="lang=='ar'" class="col-12">
              <h3>التسويق الإلكتروني</h3>
              <section class="text-justify">
                <P>
                  نساعد عملائنا للوصول للعملائهم العالمية والمستقبل وبإبتكار مستويات رقمية نجذبهم ويرغبونا في استخدامها
                  لسهولة التعامل معها.
                </P>
                <ul>
                  <li># التدقيق</li>
                  <li># التخطيط الاستراتيجي</li>
                  <li># البحوث التسويقية</li>
                  <li># التصميم الابداعي</li>
                  <li># التسويق عبر محركات البحث</li>
                  <li># التسويق عبر مواقع التواصل الاجتماعي</li>
                </ul>

              </section>
            </aside>

          </article>

        </div>

      </div>

      <div class="col-md-5 col-sm-12 m-auto p-5 hide d-none d-md-block">
        <img src="../../../../assets/images/Services/3.svg" alt="Service" class=" wow fadeInUp" data-wow-delay="0s" (load)="onLoading('Service')">
        <div [id]="'Service'" class="spinner-grow text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>

    </div>
  </div>
</section>
<!-- #endregion -->

<!-- #region Contact Us -->
<app-contactus></app-contactus>
<!-- #endregion -->

<!-- #region footer -->
<app-footer></app-footer>
<!-- #endregion -->
